var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 9.74935V13.2493C12.3332 16.166 11.1665 17.3327 8.24984 17.3327H4.74984C1.83317 17.3327 0.666504 16.166 0.666504 13.2493V9.74935C0.666504 6.83268 1.83317 5.66602 4.74984 5.66602H8.24984C11.1665 5.66602 12.3332 6.83268 12.3332 9.74935Z",
    stroke: "#313131",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 4.74935V8.24935C17.3332 11.166 16.1665 12.3327 13.2498 12.3327H12.3332V9.74935C12.3332 6.83268 11.1665 5.66602 8.24984 5.66602H5.6665V4.74935C5.6665 1.83268 6.83317 0.666016 9.74984 0.666016H13.2498C16.1665 0.666016 17.3332 1.83268 17.3332 4.74935Z",
    stroke: "#313131",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.56817e9d0eefc8bbb4833d8581a43779.svg";
export { ForwardRef as ReactComponent };